import React from 'react';
import { useTranslation } from 'react-i18next';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';
import SystemAclRoleForm from './system-acl-role-form.jsx';

function SystemAclRolePageView({
  error,
  form,
  formErrors,
  isEditing,
  isLoading,
  isSaving,
  permissionGroups,
  roleNotFound,
  cancel,
  onFormChange,
  saveRole,
  togglePermissionKey,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <FloatingAlerts
        info={isSaving ? t('systemAcl.savingInfo') : ''}
        error={error}
      />

      <div className="app-page-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2>{isEditing ? t('systemAcl.editRole') : t('systemAcl.addRole')}</h2>
          <p>{t('systemAcl.subtitle')}</p>
        </div>
        <button type="button" className="btn btn-outline-secondary" onClick={cancel} disabled={isSaving}>
          {t('common.back')}
        </button>
      </div>

      <LoadingContainer isLoading={isLoading} hasData={!roleNotFound} initialText={t('common.loading')} className="">
        {roleNotFound ? (
          <div className="card card-body text-muted">{t('systemAcl.roleNotFound')}</div>
        ) : (
          <SystemAclRoleForm
            form={form}
            formErrors={formErrors}
            permissionGroups={permissionGroups}
            isSaving={isSaving}
            isEditing={isEditing}
            onFormChange={onFormChange}
            onTogglePermissionKey={togglePermissionKey}
            onCancel={cancel}
            onSubmit={saveRole}
          />
        )}
      </LoadingContainer>
    </div>
  );
}

export default SystemAclRolePageView;
